module.exports = __webpack_public_path__ + "static/media/pdficon.505f1da0.svg";